import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import Auth0ProviderWithConfig from './Auth0ProviderWithConfig';
import './index.scss';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Auth0ProviderWithConfig>
        <App />
      </Auth0ProviderWithConfig>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
